import Vue from 'vue'
import * as moment from 'jalali-moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n'

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

export const numberFormat = (number, decimals, decPoint, thousandsSep) => {
  // eslint-disable-next-line no-param-reassign
  number = (`${number}`).replace(/[^0-9+\-Ee.]/g, '')
  const n = !Number.isFinite(+number) ? 0 : +number
  const prec = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals)
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  // eslint-disable-next-line no-shadow
  const toFixedFix = (n, prec) => {
    if ((`${n}`).indexOf('e') === -1) {
      return +(`${Math.round(`${n}e+${prec}`)}e-${prec}`)
    }
    const arr = (`${n}`).split('e')
    let sig = ''
    if (+arr[1] + prec > 0) {
      sig = '+'
    }
    return (+(`${Math.round(`${+arr[0]}e${sig}${+arr[1] + prec}`)}e-${prec}`)).toFixed(prec)
  }
  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec).toString() : `${Math.round(n)}`).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

export const humanFileSize = (bytes, dp = 1) => {
  const thresh = 1024

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`
  }

  const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh
        && u < units.length - 1
  )

  return `${bytes.toFixed(dp)} ${units[u]}`
}

export const localeDate = (
  date = null,
  format = 'YYYY/MM/DD',
  locale = 'fa',
) => {
  if (date === '') return ''
  let currentDate
  if (date === null) currentDate = moment()
  else currentDate = moment(date)
  return currentDate.locale(locale).format(format)
}
export const localeDateTime = (
  date = null,
  format = 'YYYY/MM/DD HH:mm',
  locale = 'fa',
) => localeDate(date, format, locale)

export const summaryText = (text, limit = 20) => (text.length > limit ? `${text.substr(0, limit)}...` : text)

export const getColorByValue = value => {
  const variants = {
    enable: 'success',
    disable: 'danger',
    paid: 'success',
    unpaid: 'danger',
    paying: 'warning',
    processing: 'warning',
    done: 'success',
    succeed: 'success',
    failed: 'danger',
    active: 'success',
    danger: 'warning',
    suspended: 'danger',
    open: 'success',
    close: 'danger',
    connecting: 'warning',
    stopped: 'dark',
    draft: 'warning',
    sending: 'info',
    scheduled: 'success',
    sent: 'success',
    waiting: 'danger',
    canceled: 'dark',
    affiliate: 'warning',
    commission: 'info',
    approved: 'success',
    telegram: 'info',
    whatsapp: 'success',
  }
  return variants[value.toLowerCase()]
}

export const showToastNotification = (text = '', type = 'error') => {
  if (!text) return false
  let title
  let icon
  let variant
  if (type === 'error') {
    title = i18n.t('Error')
    icon = 'XCircleIcon'
    variant = 'danger'
  } else if (type === 'warning') {
    title = i18n.t('Warning')
    icon = 'AlertTriangleIcon'
    variant = 'warning'
  } else {
    title = i18n.t('Success')
    icon = 'CheckIcon'
    variant = 'success'
  }
  return Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title,
      icon,
      variant,
      text,
    },
  })
}

export const insertAtCursor = (myField, myValue) => {
  const field = myField
  if (document.selection) {
    field.focus()
    const sel = document.selection.createRange()
    sel.text = myValue
  } else if (window.navigator.userAgent.indexOf('Edge') > -1) {
    const startPos = field.selectionStart
    const endPos = field.selectionEnd

    field.value = field.value.substring(0, startPos) + myValue
            + field.value.substring(endPos, field.value.length)

    const pos = startPos + myValue.length
    field.focus()
    field.setSelectionRange(pos, pos)
  } else if (field.selectionStart || field.selectionStart == '0') {
    const startPos = field.selectionStart
    const endPos = field.selectionEnd
    field.value = field.value.substring(0, startPos)
            + myValue
            + field.value.substring(endPos, field.value.length)
  } else {
    field.value += myValue
  }
}
export const downloadFile = (fileName, fileType, fileContent) => {
  const linkSource = `data:${fileType};base64,${fileContent}`
  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName
  return downloadLink.click()
}
export const nl2br = str => str.replace(/\n/g, '<br>')
